import { render, staticRenderFns } from "./treasury-card.vue?vue&type=template&id=39c8e8b4&scoped=true&"
import script from "./treasury-card.vue?vue&type=script&lang=js&"
export * from "./treasury-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8e8b4",
  null
  
)

export default component.exports